import { useState } from 'react';
import ScheduleButton from "../ScheduleComponent/ScheduleButton.jsx";
import ScheduleData from "../../hook/ScheduleData.js";

function ClassroomSchedule() 
{
    const [tab, setTab] = useState('spo');

    const voData  = ScheduleData('/ClassRoom', null, true);
    const spoData = ScheduleData('/ClassRoom', null, false);

    const active = tab === 'vo' ? voData : spoData;

    if (active.loading) return <div className='loading'>Загрузка...</div>;
    if (active.error)   return <div className='error'>Ошибка: {active.error}</div>;

    return (
        <div>
            <div className='edu-filter'>
                <button
                    className={`edu-filter__btn vo ${tab === 'vo' ? 'active' : ''}`}
                    onClick={() => setTab('vo')}
                >
                    Высшее образование (ВО)
                </button>
                
                <button
                    className={`edu-filter__btn spo ${tab === 'spo' ? 'active' : ''}`}
                    onClick={() => setTab('spo')}
                >
                    СПО
                </button>
            </div>

            <ScheduleButton
                data={active.data}
                url="classroom"
                title={tab === 'vo' ? 'Аудитории высшего образования' : 'Аудитории СПО'}
                displayKey="class_room"
                routeKey="class_room"
                keyField="class_room"
            />
        </div>
    );
}

export default ClassroomSchedule;